import React from "react";
import { StyledSpinner } from "../styles/StyledSpinner";

export default () => <StyledSpinner></StyledSpinner>;
